import PaymentInfoPage, { PaymentInfoPageProps } from './PaymentInfoPage';

export type { PaymentInfoPageProps };
export default PaymentInfoPage;
